var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDzaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_58355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0H60V45H30V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V45H0V0Z",
    fill: "#006233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7501 16.875C38.5119 14.7303 36.6005 13.0541 34.3125 12.1064C32.0245 11.1586 29.4877 10.9924 27.0956 11.6333C24.7035 12.2743 22.5897 13.6867 21.0821 15.6514C19.5745 17.6162 18.7573 20.0235 18.7573 22.5C18.7573 24.9765 19.5745 27.3838 21.0821 29.3486C22.5897 31.3133 24.7035 32.7257 27.0956 33.3667C29.4877 34.0076 32.0245 33.8414 34.3125 32.8936C36.6005 31.9459 38.5119 30.2697 39.7501 28.125C38.5847 29.5806 36.996 30.6383 35.2035 31.1519C33.411 31.6655 31.5032 31.6096 29.7438 30.9921C27.9844 30.3745 26.4602 29.2257 25.3819 27.7045C24.3036 26.1832 23.7245 24.3646 23.7245 22.5C23.7245 20.6354 24.3036 18.8168 25.3819 17.2955C26.4602 15.7743 27.9844 14.6255 29.7438 14.0079C31.5032 13.3904 33.411 13.3345 35.2035 13.8481C36.996 14.3617 38.5847 15.4194 39.7501 16.875ZM40.1251 22.5L30.0001 19.2L36.3001 27.825V17.175L30.0001 25.8L40.1251 22.5Z",
    fill: "#D21034"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_58355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDzaFlag);
export default __webpack_public_path__ + "static/media/dza-flag.f21d7fa203b76bac2f33fb06cf5923db.svg";
export { ForwardRef as ReactComponent };